/**
 * @description 获取消息通知列表
 */
export const getMessageGroups = () => {
  return {
    url: '/api/messageGroups/v1',
    methods: 'get',
  };
};

/**
 * @description 获取消息通知列表（用户消息）
 * @param { String } type 类别: concern(@我的)、fans(粉丝)、like(赞)、commnet(评论)、
 */
export const getInteractionList = (type, timestamp = '') => {
  return {
    url: `/api/message/v2/interaction/${type}?timestamp=${timestamp}`,
    methods: 'get',
  };
};

/**
 * @description 获取消息通知列表（官方消息）
 * @param { String } type 类别:
 * s_vip(svip专享)
 * system(系统通知)
 * live_remaind(直播提醒)
 * guru_activity(格隆汇活动)
 * community_steward(社区小管家)
 */
export const getNotificationList = (type, timestamp = '') => {
  return {
    url: `/api/message/v2/notification/${type}?timestamp=${timestamp}`,
    methods: 'get',
  };
};
